module.exports = __webpack_public_path__ + "favicon-16.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/web/favicon-16.ico
// module id = 1061
// module chunks = 0